import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import { getFlexItemClasses } from '../../../utils/getFlexItemClasses';
import { Flex } from '../../Flex';
/**
 * Renders the content of a main menu item
 */
export const MainMenuItemContent = (props) => {
    const { isActive, icon, text, suffix } = props;
    return (_jsxs(_Fragment, { children: [_jsxs(Flex, Object.assign({ alignItems: "center", className: "space-x-2" }, { children: [_jsx("div", Object.assign({ className: clsx(getFlexItemClasses({ grow: false, shrink: false }), 'w-5 text-center') }, { children: icon }), void 0),
                    _jsx("div", { children: text }, void 0)] }), void 0),
            suffix && (_jsx("div", Object.assign({ className: clsx(!isActive &&
                    'opacity-0 transition-opacity duration-100 group-hover:opacity-50 group-focus:opacity-50') }, { children: suffix }), void 0))] }, void 0));
};
//# sourceMappingURL=MainMenuItemContent.js.map